export const serviceStructuredContent = {
  traefaeldning: {
    content: [
      {
        type: "heading",
        level: 1,
        text: "Træfældning og topkapning på Mors og i Thy"
      },
      {
        type: "paragraph",
        html: "Står et træ tæt på huset, fylder det for meget, eller er du bekymret for dets tilstand? Hos <a href=\"https://www.th-skovservice.dk/\">TH Skovservice</a> hjælper vi med træfældning og topkapning for private, erhverv og det offentlige. Vi har base i Karby på Mors og vurderer den enkelte opgave med fokus på sikkerhed, dine ønsker og hensynet til omgivelserne."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Send en mail",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Træfældning med omtanke for hus og have"
      },
      {
        type: "paragraph",
        html: "Inden vi fælder et træ, ser vi på dets størrelse, tilstand og placering. Der skal være plads til faldet, og bygninger, hegn og anden beplantning skal indgå i vurderingen. Er forholdene egnede, kan træet fældes fra jorden. Er pladsen begrænset, kan det være nødvendigt at tage det ned i mindre sektioner."
      },
      {
        type: "paragraph",
        html: "Du behøver ikke selv vide, hvilken metode der passer til opgaven. Det hjælper vi dig med at afklare ved en besigtigelse. Her gennemgår vi også adgangsforholdene og taler om, hvad du gerne vil bevare omkring træet. Det giver os et fælles udgangspunkt, inden arbejdet går i gang."
      },
      {
        type: "heading",
        level: 3,
        text: "Topkapning af træer tæt på bygninger"
      },
      {
        type: "paragraph",
        html: "Topkapning af træer kan være relevant, når et træ står i en lille have eller tæt på et hus, et drivhus eller et skur. Ved sektionsvis fældning tager vi træet ned i mindre dele fra toppen. Hvor forholdene kræver det, kan delene sænkes kontrolleret ned, så der tages hensyn til omgivelserne."
      },
      {
        type: "paragraph",
        html: "Topkapning bruges også som betegnelse for kraftig beskæring af træer, der skal blive stående. Det er ikke det samme som sektionsvis fældning. Kraftig afkortning kan skade træet, og derfor vurderer vi, hvilken løsning der er mest hensigtsmæssig, hvis du ønsker at bevare det."
      },
      {
        type: "heading",
        level: 2,
        text: "Pris på træfældning"
      },
      {
        type: "paragraph",
        html: "Prisen på træfældning afhænger af mere end træets højde. Placeringen, træets tilstand og pladsen til at arbejde har også betydning. Et mindre træ tæt på et tag kan kræve mere arbejde end et større træ på en åben grund. Derfor vurderer vi opgaven konkret, inden vi giver et tilbud."
      },
      {
        type: "list",
        items: [
          "Træets højde, stammens tykkelse og kronens omfang",
          "Afstanden til bygninger, hegn og anden beplantning",
          "Adgangsforhold og plads til arbejdet",
          "Træets tilstand og den nødvendige fældemetode",
          "Omfanget af oprydning og eventuel fjernelse af stubben"
        ]
      },
      {
        type: "paragraph",
        html: "Når du sammenligner priser på træfældning, er det vigtigt at se på, hvad tilbuddene omfatter. Vi gennemgår dine ønsker, så det er tydeligt, hvilke dele af opgaven vi skal løse, og hvad der skal ske bagefter."
      },
      {
        type: "heading",
        level: 3,
        text: "Hvad koster topkapning af træer?"
      },
      {
        type: "paragraph",
        html: "Prisen på topkapning afhænger blandt andet af, hvor store sektioner der kan håndteres, og om delene skal sænkes ned. Arbejdet kræver ofte flere trin end almindelig fældning fra jorden. Derfor vurderer vi både pladsen omkring træet og arbejdets omfang, når vi giver en pris."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring og hør mere",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Skriv til os",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Oprydning og muligheder efter træfældning"
      },
      {
        type: "paragraph",
        html: "Et fældet træ efterlader både stamme, grene og en stub. Derfor er det en god idé at tænke på oprydningen allerede ved den første samtale. Fortæl os, hvordan du vil bruge arealet bagefter, og om du ønsker at beholde noget af træet på grunden."
      },
      {
        type: "paragraph",
        html: "Ved større mængder grene og træmateriale kan vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/grenknusning\">grenknusning</a> også være relevant. Hvis du ønsker ny beplantning eller at etablere et større grønt område, kan du desuden læse om vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/skovrejsning-laehegn\">skovrejsning og læhegn</a>."
      },
      {
        type: "heading",
        level: 2,
        text: "Få et tilbud på træfældning på Mors, i Thy og Skive"
      },
      {
        type: "paragraph",
        html: "Fra vores base i Karby på Mors hjælper vi med træfældning i Nykøbing Mors og på resten af Mors samt i Thisted, Thy, Skive og Struer. Vi udfører også opgaver omkring Fjerritslev og i Jammerbugt. Uanset hvor opgaven skal udføres, tager vi udgangspunkt i træets placering, omgivelserne og dine ønsker."
      },
      {
        type: "paragraph",
        html: "Kontakt TH Skovservice på <a href=\"tel:+4527432314\">27 43 23 14</a>, eller skriv til <a href=\"mailto:Thorsten.hansen94@gmail.com\">Thorsten.hansen94@gmail.com</a>. Vi tilbyder gratis besigtigelse og et uforpligtende tilbud. Du kan også <a href=\"https://www.th-skovservice.dk/kontakt\">kontakte os her</a>, hvis du vil høre mere om mulighederne."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Få et tilbud på mail",
            url: "mailto:Thorsten.hansen94@gmail.com?subject=Tilbud%20paa%20traefaeldning",
            style: "secondary"
          }
        ]
      }
    ]
  },

  "skovrejsning-laehegn": {
    content: [
      {
        type: "heading",
        level: 1,
        text: "Skovrejsning og læhegn på Mors og i Thy"
      },
      {
        type: "paragraph",
        html: "Overvejer du at plante ny skov eller etablere læhegn på din ejendom? Hos <a href=\"https://www.th-skovservice.dk/\">TH Skovservice</a> hjælper vi med skovrejsning og plantning af læhegn på Mors, i Thy og omegn. Vi har base i Karby på Mors og tager udgangspunkt i jordens forhold, arealets anvendelse og dine ønsker til den nye beplantning. Vi hjælper både private, landbrug og andre lodsejere med at finde en løsning, der passer til området."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Send en mail",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Skovrejsning tilpasset din jord og dine ønsker"
      },
      {
        type: "paragraph",
        html: "Skovrejsning handler om mere end at sætte træer i jorden. Jordbund, fugtighed, vindforhold og arealets størrelse har betydning for, hvilke træarter der kan trives. Derfor er det vigtigt at planlægge beplantningen med udgangspunkt i de lokale forhold og formålet med den nye skov."
      },
      {
        type: "paragraph",
        html: "En ny skov kan eksempelvis etableres med fokus på natur, rekreative muligheder eller fremtidig skovdrift. Vi gennemgår dine ønsker og ser på, hvordan arealet kan indrettes, så beplantningen får gode betingelser for at udvikle sig. Her kan både valg af træarter, planteafstande og den efterfølgende pleje indgå i planlægningen."
      },
      {
        type: "heading",
        level: 3,
        text: "Planlægning og etablering af ny skov"
      },
      {
        type: "paragraph",
        html: "Inden arbejdet går i gang, er det en fordel at få overblik over arealets muligheder og eventuelle begrænsninger. Vi tager udgangspunkt i jordens beskaffenhed, adgangsforholdene og den eksisterende beplantning. Det giver et bedre grundlag for at vælge en løsning, som passer til både arealet og dine forventninger."
      },
      {
        type: "paragraph",
        html: "Ved skovrejsning kan der gælde regler om arealanvendelse, beskyttede områder og eventuelle tilladelser. Der kan også være tilskudsmuligheder afhængigt af projektet og de gældende ordninger. Det er derfor vigtigt at få afklaret de relevante forhold, inden beplantningen etableres."
      },
      {
        type: "heading",
        level: 2,
        text: "Plantning af læhegn til mark og ejendom"
      },
      {
        type: "paragraph",
        html: "Et læhegn kan være med til at skabe læ omkring marker, bygninger og opholdsarealer. Samtidig kan beplantningen give variation i landskabet og skabe levesteder for fugle og andre dyr. Hos TH Skovservice hjælper vi med plantning af læhegn, hvor placering og valg af planter tilpasses de lokale forhold."
      },
      {
        type: "paragraph",
        html: "Et læhegn skal kunne udvikle sig over mange år. Derfor ser vi blandt andet på vindretning, jordbund og den plads, der er til rådighed. Afhængigt af formålet kan et læhegn bestå af forskellige træer og buske, som tilsammen giver en varieret beplantning."
      },
      {
        type: "heading",
        level: 3,
        text: "Valg af planter og forberedelse af arealet"
      },
      {
        type: "paragraph",
        html: "En god etablering begynder med den rigtige forberedelse. Vi gennemgår blandt andet følgende forhold, inden arbejdet planlægges:"
      },
      {
        type: "list",
        items: [
          "Jordbund, fugtighed og vindforhold på arealet",
          "Formålet med skoven eller læhegnet",
          "Valg af træer og buske, der passer til forholdene",
          "Planteafstande og plads til den fremtidige vækst",
          "Behov for vedligeholdelse og pleje efter plantning"
        ]
      },
      {
        type: "paragraph",
        html: "Hvis der står uønsket bevoksning på arealet, inden den nye beplantning skal etableres, kan vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/grenknusning\">grenknusning</a> også være relevant. Det afhænger af bevoksningen og de konkrete forhold på stedet."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring og hør mere",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Skriv til os",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Pris på skovrejsning og etablering af læhegn"
      },
      {
        type: "paragraph",
        html: "Prisen på skovrejsning og etablering af læhegn afhænger blandt andet af arealets størrelse, jordbundsforholdene og den type beplantning, du ønsker. Antallet af planter, behovet for forberedelse og adgangsforholdene kan også have betydning for det samlede arbejde."
      },
      {
        type: "paragraph",
        html: "Derfor vurderer vi opgaven konkret, inden vi giver et tilbud. Vi gennemgår dine ønsker og afklarer, hvad arbejdet skal omfatte, så du får et tydeligt grundlag for at planlægge projektet."
      },
      {
        type: "heading",
        level: 2,
        text: "Få hjælp til skovrejsning og læhegn på Mors og i Thy"
      },
      {
        type: "paragraph",
        html: "Fra vores base i Karby hjælper vi med skovrejsning og læhegn på Mors, herunder Nykøbing Mors, samt i Thisted og resten af Thy. Vi udfører også opgaver i Skive, Struer, omkring Fjerritslev og i Jammerbugt. Vi tager udgangspunkt i arealets forhold og dine ønsker til den nye beplantning."
      },
      {
        type: "paragraph",
        html: "Har du træer, der skal fjernes, inden arealet kan anvendes til ny beplantning, kan du også læse om vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/traefaeldning\">træfældning</a>."
      },
      {
        type: "paragraph",
        html: "Kontakt TH Skovservice på <a href=\"tel:+4527432314\">27 43 23 14</a>, eller skriv til <a href=\"mailto:Thorsten.hansen94@gmail.com\">Thorsten.hansen94@gmail.com</a>. Vi tilbyder gratis besigtigelse og et uforpligtende tilbud. Du kan også <a href=\"https://www.th-skovservice.dk/kontakt\">kontakte os via hjemmesiden</a> med oplysninger om arealets størrelse, placering og dine ønsker."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Få et tilbud på mail",
            url: "mailto:Thorsten.hansen94@gmail.com?subject=Tilbud%20paa%20skovrejsning%20og%20laehegn",
            style: "secondary"
          }
        ]
      }
    ]
  },

  groedeskaering: {
    content: [
      {
        type: "heading",
        level: 1,
        text: "Grødeskæring på Mors og i Thy med hensyn til naturen"
      },
      {
        type: "paragraph",
        html: "Har du et vandløb eller en grøft, hvor vandplanter og bevoksning påvirker vandets passage? Hos <a href=\"https://www.th-skovservice.dk/\">TH Skovservice</a> hjælper vi med grødeskæring og vedligeholdelse af vandløb og grøfter på Mors, i Thy og omegn. Vi har base i Karby på Mors og tager udgangspunkt i forholdene på stedet, vandløbets funktion og de naturhensyn, der skal tages."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Send en mail",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Grødeskæring i vandløb og grøfter"
      },
      {
        type: "paragraph",
        html: "Grødeskæring handler om at beskære eller fjerne udvalgte vandplanter, så vandet bedre kan passere gennem et vandløb eller en grøft. Arbejdet kan være relevant, hvor kraftig plantevækst påvirker vandføringen, men det er vigtigt, at indsatsen tilpasses det enkelte vandløb."
      },
      {
        type: "paragraph",
        html: "Vandplanter har samtidig betydning for livet i og omkring vandløbet. Derfor er målet ikke nødvendigvis at fjerne al bevoksning. Vi ser på forholdene og tilrettelægger arbejdet med hensyn til både vandets passage og naturen."
      },
      {
        type: "heading",
        level: 3,
        text: "Vedligeholdelse med hensyn til vandløbets forhold"
      },
      {
        type: "paragraph",
        html: "Behovet for grødeskæring afhænger blandt andet af vandløbets bredde, dybde, vandføring og plantevækst. Der kan også være forskel på, hvordan arbejdet må udføres i offentlige og private vandløb. Derfor skal gældende regulativer, vedligeholdelsesbestemmelser og eventuelle naturbeskyttelsesregler være afklaret, inden arbejdet sættes i gang."
      },
      {
        type: "paragraph",
        html: "Vi tager udgangspunkt i den konkrete opgave og de forhold, der gælder for området. På den måde kan arbejdet planlægges med fokus på en hensigtsmæssig vedligeholdelse."
      },
      {
        type: "heading",
        level: 2,
        text: "Hvornår kan der være behov for grødeskæring?"
      },
      {
        type: "paragraph",
        html: "Vandplanter vokser forskelligt afhængigt af årstid, lysforhold og vandløbets karakter. I nogle vandløb kan plantevæksten blive så tæt, at den påvirker vandets passage. Det betyder dog ikke automatisk, at der skal skæres grøde, da både tidspunkt og omfang skal vurderes i forhold til reglerne og de lokale forhold."
      },
      {
        type: "paragraph",
        html: "Ved planlægning af grødeskæring i vandløb er det blandt andet relevant at se på:"
      },
      {
        type: "list",
        items: [
          "Vandløbets størrelse, vandføring og adgangsforhold",
          "Mængden og typen af vandplanter",
          "Om plantevæksten påvirker vandets passage",
          "Gældende regulativer og eventuelle naturhensyn",
          "Tidspunktet og omfanget af den nødvendige vedligeholdelse"
        ]
      },
      {
        type: "paragraph",
        html: "Vi gennemgår opgaven, så der er et tydeligt udgangspunkt for arbejdet. Det gælder både, når der er tale om en enkelt indsats, og når et område har behov for løbende vedligeholdelse."
      },
      {
        type: "heading",
        level: 3,
        text: "Grødeskæring som en del af naturpleje"
      },
      {
        type: "paragraph",
        html: "Vedligeholdelse af vandløb og grøfter kræver ofte en afvejning mellem afvanding og naturhensyn. Vandplanter kan skabe levesteder for dyr og bidrage til variation i vandløbet, samtidig med at kraftig vækst nogle steder kan påvirke vandføringen."
      },
      {
        type: "paragraph",
        html: "Derfor tilpasses grødeskæringen de konkrete forhold frem for at behandle alle vandløb ens. Har du også behov for pleje af tilstødende grønne arealer, kan vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/grenknusning\">grenknusning</a> være relevant som en særskilt opgave."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring og hør mere",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Skriv til os",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Pris på grødeskæring"
      },
      {
        type: "paragraph",
        html: "Prisen på grødeskæring afhænger blandt andet af vandløbets længde, mængden af bevoksning og adgangsforholdene. Det har også betydning, hvordan arbejdet skal udføres, og om der gælder særlige krav til tidspunkt eller metode."
      },
      {
        type: "paragraph",
        html: "Derfor vurderer vi opgaven konkret, inden vi giver et tilbud. Vi gennemgår de relevante forhold og afklarer, hvad arbejdet skal omfatte, så du får et tydeligt grundlag for aftalen."
      },
      {
        type: "heading",
        level: 2,
        text: "Få hjælp til grødeskæring på Mors, i Thy og Skive"
      },
      {
        type: "paragraph",
        html: "Fra vores base i Karby hjælper vi med grødeskæring på Mors, herunder Nykøbing Mors, samt i Thisted og resten af Thy. Vi udfører også opgaver i Skive, Struer, omkring Fjerritslev og i Jammerbugt. Vi tager udgangspunkt i vandløbets forhold og de krav, der gælder for arbejdet."
      },
      {
        type: "paragraph",
        html: "Hos TH Skovservice arbejder vi også med andre former for pleje og vedligeholdelse af grønne områder. Du kan blandt andet læse mere om vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/skovrejsning-laehegn\">skovrejsning og læhegn</a>."
      },
      {
        type: "paragraph",
        html: "Kontakt TH Skovservice på <a href=\"tel:+4527432314\">27 43 23 14</a>, eller skriv til <a href=\"mailto:Thorsten.hansen94@gmail.com\">Thorsten.hansen94@gmail.com</a> med en beskrivelse af opgaven. Vi tilbyder gratis besigtigelse og et uforpligtende tilbud. Du kan også <a href=\"https://www.th-skovservice.dk/kontakt\">kontakte os via hjemmesiden</a>, hvis du vil høre mere."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Få et tilbud på mail",
            url: "mailto:Thorsten.hansen94@gmail.com?subject=Tilbud%20paa%20groedeskaering",
            style: "secondary"
          }
        ]
      }
    ]
  },

  grenknusning: {
    content: [
      {
        type: "heading",
        level: 1,
        text: "Grenknusning på Mors og i Thy til skov og grønne arealer"
      },
      {
        type: "paragraph",
        html: "Har du grene, krat eller tæt bevoksning, der skal håndteres på din ejendom? Hos <a href=\"https://www.th-skovservice.dk/\">TH Skovservice</a> hjælper vi med grenknusning på skovarealer, naturgrunde og andre grønne områder. Vi har base i Karby på Mors og udfører opgaver for private, erhverv og det offentlige. Vi tager udgangspunkt i arealets forhold og dine ønsker til det færdige resultat."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Send en mail",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Grenknusning af grene, krat og bevoksning"
      },
      {
        type: "paragraph",
        html: "Grenknusning kan være en løsning, når grene, mindre træagtig bevoksning og krat skal nedbrydes på et areal. Ved mekanisk knusning findeles materialet, så det fylder mindre og bliver lettere at håndtere. Metoden kan blandt andet være relevant i forbindelse med vedligeholdelse af skovarealer, naturgrunde og områder med uønsket opvækst."
      },
      {
        type: "paragraph",
        html: "Hvilken løsning der passer bedst, afhænger af bevoksningens tæthed, materialets størrelse og adgangsforholdene. Vi vurderer derfor opgaven konkret, inden arbejdet planlægges. På den måde kan vi tage højde for både maskinernes muligheder og de områder, der skal bevares."
      },
      {
        type: "heading",
        level: 3,
        text: "Grenknusning som en del af naturpleje"
      },
      {
        type: "paragraph",
        html: "Ved pleje af grønne arealer kan knusning af krat og bevoksning være med til at skabe mere åbne områder. Det kan eksempelvis være relevant, hvor opvæksten har bredt sig, eller hvor et areal skal gøres mere tilgængeligt."
      },
      {
        type: "paragraph",
        html: "Arbejdet skal dog tilpasses forholdene på stedet. Eksisterende beplantning, terræn og eventuelle naturhensyn kan have betydning for, hvordan opgaven udføres. På beskyttede arealer kan der desuden gælde særlige regler, som skal være afklaret, inden arbejdet begynder."
      },
      {
        type: "heading",
        level: 2,
        text: "Grenknusning i skov og på større arealer"
      },
      {
        type: "paragraph",
        html: "På skovarealer kan der være behov for at håndtere grene, krat og mindre opvækst i forbindelse med vedligeholdelse eller klargøring af et område. Her kan grenknusning være relevant, hvis forholdene egner sig til mekanisk bearbejdning."
      },
      {
        type: "paragraph",
        html: "Vi ser blandt andet på, hvor tæt bevoksningen står, hvor meget plads der er til arbejdet, og om der er særlige hensyn til eksisterende træer eller beplantning. Det er også vigtigt at afklare, hvad der skal ske med det knuste materiale bagefter."
      },
      {
        type: "heading",
        level: 3,
        text: "Forberedelse af arealet inden grenknusning"
      },
      {
        type: "paragraph",
        html: "En god forberedelse gør det lettere at vurdere arbejdets omfang. Inden vi går i gang, gennemgår vi derfor de forhold, der kan påvirke opgaven."
      },
      {
        type: "list",
        items: [
          "Arealets størrelse og den type bevoksning, der skal knuses",
          "Terræn, jordbund og eventuelle bløde eller ujævne områder",
          "Adgangsforhold og plads til maskiner",
          "Træer, hegn og anden beplantning, der skal bevares",
          "Ønsker til håndtering af det knuste materiale"
        ]
      },
      {
        type: "paragraph",
        html: "Hvis arealet efterfølgende skal bruges til ny beplantning, kan du også læse om vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/skovrejsning-laehegn\">skovrejsning og læhegn</a>. Det er en anden type opgave, men kan være relevant som næste skridt i planlægningen af arealet."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring og hør mere",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Skriv til os",
            url: "mailto:Thorsten.hansen94@gmail.com",
            style: "secondary"
          }
        ]
      },
      {
        type: "heading",
        level: 2,
        text: "Pris på grenknusning"
      },
      {
        type: "paragraph",
        html: "Prisen på grenknusning afhænger blandt andet af arealets størrelse, mængden af grene og bevoksning samt forholdene på stedet. Et åbent areal med gode adgangsforhold kan være lettere at arbejde på end et område med tæt krat, ujævnt terræn eller begrænset plads."
      },
      {
        type: "paragraph",
        html: "Det har også betydning, hvor kraftigt materialet er, og hvor omfattende arbejdet bliver. Derfor vurderer vi opgaven, før vi giver en konkret pris."
      },
      {
        type: "paragraph",
        html: "Når du sammenligner priser på grenknusning, er det en fordel at undersøge, hvad tilbuddet omfatter. Vi gennemgår dine ønsker og afklarer, hvilke områder der skal behandles, og hvad der skal ske med det knuste materiale. Det giver et tydeligt udgangspunkt for aftalen."
      },
      {
        type: "heading",
        level: 2,
        text: "Få hjælp til grenknusning på Mors, i Thy og Skive"
      },
      {
        type: "paragraph",
        html: "Fra vores base i Karby udfører vi grenknusning på Mors, herunder Nykøbing Mors, samt i Thisted og resten af Thy. Vi hjælper også med opgaver i Skive, Struer, omkring Fjerritslev og i Jammerbugt. Uanset hvor arealet ligger, tager vi udgangspunkt i bevoksningen, adgangsforholdene og dine ønsker."
      },
      {
        type: "paragraph",
        html: "Har du også træer, der skal fældes, inden arealet kan bearbejdes, kan du læse mere om vores arbejde med <a href=\"https://www.th-skovservice.dk/ydelser/traefaeldning\">træfældning</a>."
      },
      {
        type: "paragraph",
        html: "Kontakt TH Skovservice på <a href=\"tel:+4527432314\">27 43 23 14</a>, eller skriv til <a href=\"mailto:Thorsten.hansen94@gmail.com\">Thorsten.hansen94@gmail.com</a> med en beskrivelse af opgaven. Vi tilbyder gratis besigtigelse og et uforpligtende tilbud. Du kan også <a href=\"https://www.th-skovservice.dk/kontakt\">kontakte os via hjemmesiden</a>, gerne med billeder og oplysninger om arealets størrelse og placering."
      },
      {
        type: "cta",
        buttons: [
          {
            label: "Ring til os",
            url: "tel:+4527432314",
            style: "primary"
          },
          {
            label: "Få et tilbud på mail",
            url: "mailto:Thorsten.hansen94@gmail.com?subject=Tilbud%20paa%20grenknusning",
            style: "secondary"
          }
        ]
      }
    ]
  }
};
